import { AfterViewInit, Component } from '@angular/core';
import { isMobile } from '../../functions/isMobile';
import { AdsService } from '../../services/ads.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-pop-up-ad',
  templateUrl: './pop-up-ad.component.html',
  styleUrls: ['./pop-up-ad.component.css'],
})
export class PopUpAdComponent implements AfterViewInit {
  videoUrl?: string;
  mime: string = '';
  adId!: number;
  viewTimeInSeconds: number = 0;
  intervalRef: any;
  isPlaying = false;

  constructor(
    private adsService: AdsService,
    private utilService: UtilService
  ) {}

  ngAfterViewInit(): void {
    const alreadyRun = sessionStorage.getItem('pop-up-ad');
    if (alreadyRun) return;

    this.startAd();

    sessionStorage.setItem('pop-up-ad', 'ok');
  }

  async startVideo(evt: Event) {
    const vid = evt.target as HTMLVideoElement;
    vid.muted = true;
    vid.playsInline = true;
    vid.defaultMuted = true;

    vid.addEventListener('play', () => {
      this.startCounter();
      this.isPlaying = true;
    });

    setTimeout(async () => {
      try {
        await vid.play();
      } catch (error) {
        console.log("ERROR PLAYING: ", error)
      }
    }, 100);
  }

  async endVideo() {
    this.isPlaying = false;
    if (!this.videoUrl) return;
    clearInterval(this.intervalRef);
    this.adsService.popupAdAnalytics({
      adId: this.adId,
      durationInSeconds: this.viewTimeInSeconds,
    });
    this.videoUrl = undefined;
  }

  private startCounter() {
    setTimeout(() => {
      const videoEl = document.getElementById(
        'adVideo'
      ) as HTMLVideoElement | null;
      if (!videoEl) {
        throw new Error('Unable to find video element');
      }

      videoEl.classList.add('exit');

      setTimeout(() => {
        this.endVideo();
      }, 500);
    }, 8 * 1000);

    this.intervalRef = setInterval(() => {
      this.viewTimeInSeconds++;
    }, 1000);
  }

  private async startAd() {
    const ad = await this.adsService.getPopAd();
    if (!ad) return;

    this.adId = ad.id;
    const url = isMobile() ? ad.mobile_ad.url : ad.desktop_ad.url;
    this.videoUrl = this.utilService.getAbsoluteUrl(url ?? '');
    this.mime = isMobile() ? ad.mobile_ad.mime : ad.desktop_ad.mime;
  }
}
